import { styled } from "@mui/material/styles";


export const PromptWrapper = styled("div")(({ theme }) => ({
  position: "fixed",
  zIndex: 300,
  bottom: 0,
  boxShadow: "0px 0px 8px rgba(51, 51, 51, 0.1)",
  width: "100%",
  height: "58px",
  left: 0,
  backgroundColor: theme.palette.grayScale.white,
}));

export const PromptContent = styled("div")({
  margin: "0px 100px",
  display: "flex",
  justifyContent: "flex-end",
  "button:nth-of-type(2)": {
    marginLeft: "20px",
  },
});
